var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.params.data.referencias_link != "[]"
    ? _c(
        "ul",
        { staticClass: "listarefs" },
        _vm._l(JSON.parse(this.params.data.referencias_link), function(item) {
          return _c("li", { key: item }, [
            _c(
              "a",
              { attrs: { href: item.split("__")[1], target: "_blank" } },
              [_vm._v(_vm._s(item.split("__")[0]))]
            )
          ])
        }),
        0
      )
    : _c("p", [_vm._v("--")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }